import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSetTimerStore = defineStore('setTimer', () => {
  const clusterId = ref(0)
  const agentLevel = ref('')
  const zoneId = ref(0)
  const setTimerDialogVisible = ref(false)

  const setTimerInfo = (
    clickedClusterId: number,
    clickedAgentLevel: string,
    clickedZoneId = 0
  ): void => {
    clusterId.value = clickedClusterId
    agentLevel.value = clickedAgentLevel
    zoneId.value = clickedZoneId
    setTimerDialogVisible.value = true
  }

  const addTimerDialogVisible = ref(false)
  const deleteTimerDialogVisible = ref(false)
  const selectTimerRuleDialogVisible = ref(false)
  const timerRuleDialogVisible = ref(false)
  const deleteTimerRoleDialogVisible = ref(false)
  const refreshSetTimer = ref(0)
  const refreshTimerRule = ref(0)
  const currRuleId = ref(0)

  const addTimerRule = () => {
    currRuleId.value = 0
    timerRuleDialogVisible.value = true
  }

  const editTimerRule = (ruleId: number) => {
    currRuleId.value = ruleId
    timerRuleDialogVisible.value = true
  }

  const deleteTimerRole = (ruleId: number) => {
    currRuleId.value = ruleId
    deleteTimerRoleDialogVisible.value = true
  }

  return {
    clusterId,
    agentLevel,
    zoneId,
    setTimerDialogVisible,
    setTimerInfo,
    addTimerDialogVisible,
    deleteTimerDialogVisible,
    selectTimerRuleDialogVisible,
    timerRuleDialogVisible,
    deleteTimerRoleDialogVisible,
    refreshSetTimer,
    refreshTimerRule,
    addTimerRule,
    editTimerRule,
    deleteTimerRole,
    currRuleId
  }
})
